import { Box, Button, Divider } from '@capitalise/ui-design-system';
import { MouseEventHandler } from 'react';
import HelpFacesImage from 'assets/svgs/help-faces.svg';

export interface IScheduleButtonProps {
  helpLabel: JSX.Element;
  buttonLabel: string;
  onClickCallback: MouseEventHandler<HTMLButtonElement>;
}

const ScheduleButton = ({ helpLabel, buttonLabel, onClickCallback }: IScheduleButtonProps) => {
  return (
    <Box display="flex" flexDirection="column" gridGap="3xsmall">
      <Divider color="grey-50" />
      <Box display="flex" gridGap="3xsmall">
        <Box flex="1">
          {helpLabel}
          <Button mt="4xsmall" baseColor="green" onClick={onClickCallback} variant="outlined">
            {buttonLabel}
          </Button>
        </Box>
        <Box display="flex" alignItems="center">
          <HelpFacesImage />
        </Box>
      </Box>
      <Divider color="grey-50" />
    </Box>
  );
};

export default ScheduleButton;
